import { querySelectorAll } from '../helpers'
export function initializeFaq() {  
  let hash = window.location.hash
  if (hash){
    const elem = document.getElementById(hash.slice(1)) as HTMLInputElement;
    if (elem && elem.classList.contains('faq_toggle')){      
      elem.checked = true
    }
    
  }
}